import React from "react";
import {Route, Routes,Navigate} from "react-router-dom";
import utils from "../utils";
import {useSelector} from "react-redux";

export default ({routes, defaultRoute, isMain = false}) => {
    const {user} = useSelector(state => state.user)
    return <Routes>
        {routes.map((route, idx) => isMain ? utils.mainRouteMap(route, idx) : utils.routeMap(route, idx, user))}
        <Route
            path="*"
            element=<Navigate to={defaultRoute} replace={true}/>
        />
    </Routes>
}

